import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

import type { CustomerListItem } from "../components/SupplierNetwork/types";

interface CustomersResponse {
  customers: CustomerListItem[];
}

interface UseSupplierCustomersReturn {
  data: CustomerListItem[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useSupplierCustomers(): UseSupplierCustomersReturn {
  const { role } = useRoleContext();

  if (role && role.type !== "SHIPPER") {
    throw new Error("useSupplierCustomers can only be used by shipper users");
  }

  const url = role ? `/shippers/${role.id}/customers` : null;

  const { data, loading, error, refetch } = useSwrFetch<CustomersResponse>({
    url,
    errorMessage: "Failed to fetch customer network data",
  });

  return {
    data: data?.customers ?? [],
    loading,
    error,
    refetch,
  };
}
